import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { ApplicationService } from "@core/data/application.service";
import { ApplicationProgressSharedService } from "@core/data/application-progress-shared.service";
import { map, switchMap } from "rxjs/operators";
import { AppConstants } from "@core/constants/app";
import { ApplicationProgressResponse } from "@core/interfaces/api-responses";

export function ApplicationStatusNewGuardFn(
    next: ActivatedRouteSnapshot,
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const applicationProgressSharedService: ApplicationProgressSharedService = inject(ApplicationProgressSharedService);
    const applicationService: ApplicationService = inject(ApplicationService);
    const router: Router = inject(Router);

    const applicationId = next.params?.applicationId;
    if (!applicationId) {
        return false;
    }
    return applicationService.getProgress(applicationId).pipe(
        switchMap((stepsProgress: ApplicationProgressResponse) => {
            applicationProgressSharedService.sendData(stepsProgress);
            return applicationProgressSharedService.getData();
        }),
        map((stepsProgress: ApplicationProgressResponse) => {
            if (stepsProgress.status === AppConstants.APP_STATUS_SUBMITTED) {
                router.navigate([AppConstants.CONFIRMATION_PAGE, applicationId]);
                return false;
            }

            return stepsProgress.status === AppConstants.APP_STATUS_PENDING;
        }),
    );
}
